import classNames from 'classnames'

import { ICON_HEIGHT_24 } from '../../Icon'
import { ButtonIcon } from '../ButtonIcon'

import { BUTTON_ICON_MINIMIZE_POSITION } from './ButtonIconMinimize.constants'
import { getButtonIconMinimizePositionClassName } from './ButtonIconMinimize.utils'

import * as styles from './ButtonIconMinimize.module.css'

import MinimizeIcon from '../../../icons/minimize.svg'

function ButtonIconMinimize({
  Icon = MinimizeIcon,
  className = styles.ButtonIconMinimize,
  height = ICON_HEIGHT_24,
  iconPosition = BUTTON_ICON_MINIMIZE_POSITION.bottom,
  ...restProps
}) {
  const buttonClassName = classNames(
    className,
    styles[getButtonIconMinimizePositionClassName(iconPosition, height)]
  )

  return (
    <ButtonIcon
      {...restProps}
      Icon={Icon}
      className={buttonClassName}
      height={height}
    />
  )
}

export default ButtonIconMinimize
